import AutoDelivery from './AutoDelivery';
export default AutoDelivery;
